<template>
  <div class="app">
    <main class="main">
        <div class="container-fluid">
            <router-view></router-view>
        </div>
    </main>
  </div>
</template>

<script>

export default {
  name: 'blank',
  data () {
    return {
      
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  }
}
</script>
